export default "__VITE_ASSET__0ffeaa81__"